/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Hub_HintInputs */

const en_us2_clubs_hub_hint = /** @type {(inputs: Clubs_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenges with friends, in goals mode`)
};

const pt_br2_clubs_hub_hint = /** @type {(inputs: Clubs_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafios com amigos, no modo metas`)
};

const es_419_clubs_hub_hint = /** @type {(inputs: Clubs_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafíos con amigos, en modo metas`)
};

const pt_pt2_clubs_hub_hint = /** @type {(inputs: Clubs_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafios com amigos, no modo objetivos`)
};

const fr_fr2_clubs_hub_hint = /** @type {(inputs: Clubs_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des défis entre amis, en mode objectifs`)
};

const de_de2_clubs_hub_hint = /** @type {(inputs: Clubs_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenges mit Freunden, im Zielmodus`)
};

const it_it2_clubs_hub_hint = /** @type {(inputs: Clubs_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfide con gli amici, a obiettivi`)
};

/**
* | output |
* | --- |
* | "Challenges with friends, in goals mode" |
*
* @param {Clubs_Hub_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_hub_hint = /** @type {((inputs?: Clubs_Hub_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Hub_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_hub_hint(inputs)
	if (locale === "es-419") return es_419_clubs_hub_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_hub_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_hub_hint(inputs)
	if (locale === "de-DE") return de_de2_clubs_hub_hint(inputs)
	if (locale === "it-IT") return it_it2_clubs_hub_hint(inputs)
	return en_us2_clubs_hub_hint(inputs)
});
export { clubs_hub_hint as "clubs.hub_hint" }